import React from "react";
import { toast } from "sonner";
import { Facebook, Twitter, Send, MessageCircle, Copy, Share2 } from "lucide-react";

export function ShareButtons({ url, title, label = "Partager" }) {
  const text = `${title} ${url}`;
  const links = [
    { id: "whatsapp", Icon: MessageCircle, name: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent(text)}`, cls: "hover:border-neon-green hover:text-neon-green" },
    { id: "facebook", Icon: Facebook, name: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, cls: "hover:border-blue-400 hover:text-blue-400" },
    { id: "twitter", Icon: Twitter, name: "X", href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`, cls: "hover:border-zinc-300 hover:text-white" },
    { id: "telegram", Icon: Send, name: "Telegram", href: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`, cls: "hover:border-sky-400 hover:text-sky-400" },
  ];
  const copy = () => {
    Promise.resolve(navigator.clipboard?.writeText(url)).catch(console.error);
    toast.success("Lien copié !", { style: { background: "#121212", color: "#9dff00", border: "1px solid #9dff00" } });
  };
  const nativeShare = () => navigator.share({ title, url }).catch(console.error);
  return (
    <div data-testid="share-buttons" className="flex items-center gap-1.5 flex-wrap">
      <span className="text-zinc-500 text-[11px] uppercase font-bold mr-1 flex items-center gap-1"><Share2 className="h-3.5 w-3.5" /> {label}</span>
      {links.map(({ id, Icon, name, href, cls }) => (
        <a key={id} data-testid={`share-${id}`} href={href} target="_blank" rel="noopener noreferrer" title={`Partager sur ${name}`}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center justify-center h-8 w-8 border border-zinc-700 text-zinc-400 transition-colors ${cls}`}>
          <Icon className="h-4 w-4" />
        </a>
      ))}
      <button data-testid="share-copy" onClick={(e) => { e.stopPropagation(); copy(); }} title="Copier le lien"
        className="inline-flex items-center justify-center h-8 w-8 border border-zinc-700 text-zinc-400 hover:border-neon-magenta hover:text-neon-magenta transition-colors">
        <Copy className="h-4 w-4" />
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button data-testid="share-native" onClick={(e) => { e.stopPropagation(); nativeShare(); }} title="Partager…"
          className="inline-flex items-center justify-center h-8 w-8 border border-zinc-700 text-zinc-400 hover:border-neon-green hover:text-neon-green transition-colors">
          <Share2 className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
